import { render, staticRenderFns } from "./TrackHeader.vue?vue&type=template&id=b8579032&scoped=true&"
import script from "./TrackHeader.vue?vue&type=script&lang=js&"
export * from "./TrackHeader.vue?vue&type=script&lang=js&"
import style0 from "./TrackHeader.vue?vue&type=style&index=0&id=b8579032&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8579032",
  null
  
)

export default component.exports